import React, {useEffect, useState} from "react";
import {apiGetCustomField} from "../../../Admin/pages/CustomField/Actions";
import {FiPlus} from "react-icons/fi";
import {FieldArray} from "react-final-form-arrays";
import {EnigooSelect} from "../../EnigooSelect";
import {EnigooSwitch} from "../../EnigooSwitch";
import {EnigooTextField} from "../../EnigooTextField";
import {EnigooFieldsGroup} from "../../EnigooFieldsGroup";
import {EnigooCustomField} from "../../EnigooCustomField";
import {useTranslation} from "react-i18next";
import {shallowEqual, useSelector} from "react-redux";
import DragAndDropComponent from "../../DragAndDrop/DragAndDropComponent";

export const CustomFieldsAssign = ({
                                       label,
                                       fieldName,
                                       doPush,
                                       defaultSelectValues,
                                       type = null,
                                       values,
                                   }) => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let fieldsNumber = 0;
    let [selectCustomField, setSelectCustomField] = useState(null);
    let [dataForSelect, setDataForSelect] = useState([]);
    const {t} = useTranslation()
    let actualFields = null;

    useEffect(() => {
        if (data && actualFields) {
            let array = [];
            data.forEach((item, index) => {
                if (!actualFields || !actualFields.value || !actualFields.value.some((i) => i.id === item.id)) {
                    array.push(item);
                }
            })
            setDataForSelect(array);
            setSelectCustomField(null);
        }
    }, [actualFields, data]);

    useEffect(() => {
        get();
    }, []);


    const get = () => {
        setLoading(true);
        apiGetCustomField((data) => {
            setData(data);
            let array = [];
            data.map((item, index) => {
                array.push({
                    id: item.id,
                    name: item.name
                })
            })
            setDataForSelect(array);
            setLoading(false);
        }, (error) => {
            setLoading(false);
        })
    }

    const onValueChange = (event) => {
        setSelectCustomField(event);
    }

    const addValue = () => {
        doPush(fieldName, {id: selectCustomField.value, name: selectCustomField.label})
        let selArray = [];
        dataForSelect.forEach((item, index) => {
            if (selectCustomField.value !== item.id) {
                selArray.push(item);
            }
        })
        setDataForSelect(selArray);
        setSelectCustomField(null);
    }

    const ButtonAdd = () => (
        <div className={"form-element"}>
            <div className={"form-label"}>{t("webChannels.assign")}</div>
            <button disabled={selectCustomField === null}
                    onClick={() => {
                        addValue();
                    }}
                    className={"btn btn-default btn-rounded btn-icon hover:bg-enigoo-600 bg-enigoo-500 text-white"}>
                <FiPlus size={10}/>
            </button>
        </div>
    )

    const getCustomFieldById = (id) => {
        let cf = null;
        data && data.map((item, index) => {
            if (item.id === id) {
                cf = item;
            }
        })
        return cf;

    }

    const getItemsForDragAndDrop = (fields, values) => {
        let array = [];
        if (!fields) return array;
        fields.map((name, index) => {
            let newName = name.replace('[', "-");
            newName = newName.replace(']', '-');
            console.log(newName);
            array.push({
                draggableId: name,
                key: name,
                index: index,
                component: {
                    headerLeft: <>
                        <div>#{index + 1} {fields.value[index].name}:</div>
                    </>,
                    headerRight: <div className="text-right">
                        <span
                            onClick={() => {
                                let selArray = dataForSelect ? dataForSelect : [];
                                selArray.push({
                                    name: fields.value[index].name,
                                    id: fields.value[index].id
                                });
                                setDataForSelect(selArray);
                                fields.remove(index);
                            }}
                            className="cursor-pointer inline-block"
                        >
                            ❌
                        </span>
                    </div>,
                    content: <CustomFieldAssignField type={type} fields={fields} name={name}
                                                     index={index}
                                                     getCustomFieldById={getCustomFieldById}
                                                     dataForSelect={dataForSelect}
                                                     setDataForSelect={setDataForSelect}/>
                }
            })
        })
        return array;
    }

    const sortCustomFields = (fields, result) => {
        if (!result.destination) return;
        const items = fields.value.slice();
        const [removed] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, removed);
        // 2. Přepočítej pozice podle nového pořadí
        const updatedItems = items.map((item, index) => ({
            ...item,
            position: index,  // nebo od 0 podle potřeby
        }));

        updatedItems.forEach((item, index) => {
            fields.update(index, item);
        });
    }


    return (
        <>
            <div className="flex flex-col mt-1 mb-2 lg:space-x-2 text-sm w-full">
                <EnigooFieldsGroup items={[
                    <EnigooSelect disabled={loading} label={label} name={"customFieldsSelect"} items={dataForSelect}
                                  defaultValue={["id", "name"]} placeHolder={t("placeHolder.select")}
                                  onValueChange={onValueChange} key={"0"} outsideClassName={"w-full lg:w-11/12"}/>,
                    <ButtonAdd key={"1"}/>
                ]}/>
            </div>
            <FieldArray name={fieldName}>
                {({fields}) => {
                    actualFields = fields;
                    fieldsNumber = fields.length;
                    return (
                        <>{!loading &&
                            <DragAndDropComponent
                                header={<div className={"form-label"}>{t("action.selectedUserFields")}:</div>}
                                items={getItemsForDragAndDrop(fields, values)}
                                onDragEnd={({source, destination}) => {
                                    if (!destination) return;
                                    sortCustomFields(fields, {source, destination});
                                }}
                            />
                        }
                        </>
                    )
                }}
            </FieldArray>
        </>
    )
}

const CustomFieldAssignField = ({
                                    type,
                                    fields,
                                    name,
                                    index,
                                    getCustomFieldById,
                                    dataForSelect,
                                    setDataForSelect
                                }) => {
    let [notShow, setNotShow] = useState(false);
    const {t, i18n} = useTranslation()
    useEffect(() => {
        if (fields.value[index].notShow) {
            setNotShow(true);
        }
    })

    const {palettes} = useSelector(
        (state) => ({
            palettes: state.reducerAdmin.palettes
        }),
        shallowEqual
    )

    const {background, leftSidebar, navbar} = palettes;

    let isDark = React.useMemo(() => {
        return background === "dark" && leftSidebar === "dark" && navbar === "dark";
    }, [background, leftSidebar, navbar])

    return (
        <div className={`text-sm ${isDark ? "bg-grey-800" : ""}`}>
            <div
                className={`grid text-sm mt-2 ${(type && type === "webChannel") ? "lg:grid-cols-2  grid-cols-2" : "grid-cols-2"}`}>
                <EnigooTextField label={""} name={"id"} visible={false}/>
                <EnigooSwitch name={`${name}.isMandatory`} label={t("basics.requireField") + ": "}/>
                {type && type === "webChannel" &&
                    <>
                        <EnigooSwitch name={`${name}.notShow`} label={t("webChannels.notShow") + ": "}
                                      setChecked={setNotShow}/>
                        {notShow && <div className={"col-span-2 w-full justify-end"}><EnigooCustomField
                            label={t("webChannels.defaultValue") + ":"}
                            customField={getCustomFieldById(fields.value[index].id)} name={`${name}.defaultValue`}/>
                        </div>}
                    </>
                }

            </div>
        </div>
    )
}
